/* eslint no-console: 0 */
/*
 * Note: these beacons are loaded as part of the Rosetta application bundle.
 * To see beacons that are loaded in the <head> tag, before the Rosetta
 * application bundle, see `loadBeaconsCritical.js`.
 */

import { onProductionHostname } from './env';
import loadGoogleAnalytics from '../vendor/beacons/googleAnalytics';
import tagManager from '../vendor/beacons/tagManager';
import nielsen from '../vendor/beacons/nielsen';
import pinterest from '../vendor/beacons/pinterest';
import sailthruHorizon from '../vendor/beacons/sailthruHorizon';
import skimlinks from '../vendor/beacons/skimlinks';
import parsely from '../vendor/beacons/parsely';
import twitter from '../vendor/beacons/twitter';
import setDataLayerConsentVariables from '../vendor/beacons/setDataLayerConsentVariables';

export const loadBeacons = (store) => {
  const {
    ads: { ad_data },
    i18n: { edition_data, geolocation },
    analytics: { page_type }
  } = store.getState();
  const onProduction = onProductionHostname();

  /*
   * CRITICAL beacons -- these are loaded with
   * `loadScriptInHeadImmediately` instead of
   * `loadScriptInHead`
   */
  loadGoogleAnalytics(window);
  // Non-critical beacons -- loaded with `loadScriptInHead`
  tagManager(edition_data, document, onProduction, geolocation);
  setDataLayerConsentVariables(window, geolocation);
  nielsen(ad_data, geolocation, onProduction);
  pinterest(edition_data);
  sailthruHorizon();
  skimlinks(edition_data, page_type);
  twitter();
  parsely(onProduction);
};

export const loadPreviewBeacons = (store) => {
  const {
    i18n: { edition_data, geolocation }
  } = store.getState();

  const onProduction = onProductionHostname();

  tagManager(edition_data, document, onProduction, geolocation);
  pinterest(edition_data);
};
